import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media ${({ theme }) => theme.device.mobile} {
    height: 100%;
  }
`;

export const ResultImage = styled.img`
  margin-bottom: 32px;
  width: 80px;
`;
